import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabIVA as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabIVA = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const movedUpGradeLevelField = () => {
    const propertyName = pn<AprResponseModel>("movedUpGradeLevel");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.movedUpGradeLevel} {formatPercentTotal(props.data?.movedUpGradeLevel, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const repeatedGradeLevelField = () => {
    const propertyName = pn<AprResponseModel>("repeatedGradeLevel");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.repeatedGradeLevel} {formatPercentTotal(props.data?.repeatedGradeLevel, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const dropOutsField = () => {
    const propertyName = pn<AprResponseModel>("dropOuts");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.dropOuts} {formatPercentTotal(props.data?.dropOuts, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const deceasedField = () => {
    const propertyName = pn<AprResponseModel>("deceased");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.deceased} {formatPercentTotal(props.data?.deceased, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const other4AField = () => {
    const propertyName = pn<AprResponseModel>("other4A");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.other4A} {formatPercentTotal(props.data?.other4A, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknown4AField = () => {
    const propertyName = pn<AprResponseModel>("unknown4A");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknown4A}{" "}
        {formatPercentTotal(props.data?.unknown4A, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">
          Educational Status of Middle and Non-Senior High School Participants
        </Typography>
        <Grid container spacing="lg">
          <Grid item xs={6}>
            <Grid container spacing="lg">
              {props.data?.movedUpGradeLevel != null && (
                <Grid item xs={12}>
                  {movedUpGradeLevelField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.repeatedGradeLevel != null && (
                <Grid item xs={12}>
                  {repeatedGradeLevelField()}
                </Grid>
              )}

              {props.data?.dropOuts != null && (
                <Grid item xs={12}>
                  {dropOutsField()}
                </Grid>
              )}

              {props.data?.deceased != null && (
                <Grid item xs={12}>
                  {deceasedField()}
                </Grid>
              )}

              {props.data?.other4A != null && (
                <Grid item xs={12}>
                  {other4AField()}
                </Grid>
              )}

              {props.data?.unknown4A != null && (
                <Grid item xs={12}>
                  {unknown4AField()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          {/* <Grid item xs={6}>
            <PieChart
              id="pie-tab-a"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
